import React from "react";
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBBtn,
  MDBIcon,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
} from "mdb-react-ui-kit";
import TransactionForm from "Projects/CCON_cubiconta_project/Components/TransactionForm/TransactionForm";
import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import "./TransactionModal.css";

const FREQUENCY_UNITS = [
  { value: "DIAS", label: "Dias" },
  { value: "SEMANAS", label: "Semanas" },
  { value: "MESES", label: "Meses" },
  { value: "ANIOS", label: "Anios" },
];

const PERIODICIDADES = [
  { value: "MENSUAL", label: "Mensual" },
  { value: "BIMESTRAL", label: "Bimestral" },
  { value: "TRIMESTRAL", label: "Trimestral" },
  { value: "ANUAL", label: "Anual" },
];

export class TransactionModal extends React.Component {
  constructor(props) {
    super(props);

    const userDataJson = sessionStorage.getItem("userData");
    const userData = userDataJson ? JSON.parse(userDataJson) : {};
    const now = new Date();

    this.state = {
      data: this.buildInitialData(props, userData),
      saving: false,
      error: "",
      activeTab: "transaccion",
      prorrateoEnabled: false,
      prorrateo: {
        numCuotas: 2,
        fechaPrimeraCuota: this.toDateInputValue(now),
        frecuenciaValor: 1,
        frecuenciaUnidad: "MESES",
        alinearInicioPeriodo: true,
      },
      cuotasPreview: [],
      cuotasResumen: {
        totalEsperado: 0,
        totalAsignado: 0,
        diferencia: 0,
      },
      // Presupuesto tab state
      childTransaction: null,
      parentPresupuesto: null,
      loadingLinked: false,
      presupuestosPlanificados: [],
      vinculoMode: "existente",
      vinculoIdTxPresupuesto: "",
      vinculoIdCuentaPresupuesto: "",
      mostrarFormAsociar: false,
      pendingPresupuestoLink: null,
      // Conversion opcional: transaccion -> gasto periodico
      convertirEnGastoPeriodico: false,
      periodicidadGastoPeriodico: "MENSUAL",
      fechaFinGastoPeriodico: "",
    };
  }

  componentDidMount() {
    this.rebuildCuotasPreview();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.show &&
      (!prevProps.show || prevProps.mode !== this.props.mode || prevProps.data !== this.props.data)
    ) {
      const userDataJson = sessionStorage.getItem("userData");
      const userData = userDataJson ? JSON.parse(userDataJson) : {};
      const now = new Date();

      this.setState(
        {
          data: this.buildInitialData(this.props, userData),
          saving: false,
          error: "",
          activeTab: "transaccion",
          prorrateoEnabled: false,
          prorrateo: {
            numCuotas: 2,
            fechaPrimeraCuota: this.toDateInputValue(now),
            frecuenciaValor: 1,
            frecuenciaUnidad: "MESES",
            alinearInicioPeriodo: true,
          },
          cuotasPreview: [],
          childTransaction: null,
          parentPresupuesto: null,
          loadingLinked: false,
          presupuestosPlanificados: [],
          vinculoMode: "existente",
          vinculoIdTxPresupuesto: "",
          vinculoIdCuentaPresupuesto: "",
          mostrarFormAsociar: false,
          pendingPresupuestoLink: null,
          convertirEnGastoPeriodico: false,
          periodicidadGastoPeriodico: "MENSUAL",
          fechaFinGastoPeriodico: "",
        },
        this.rebuildCuotasPreview
      );
    }

    // Load linked data when switching to presupuesto tab (edit mode or new mode)
    if (
      this.state.activeTab === "presupuesto" &&
      prevState.activeTab !== "presupuesto"
    ) {
      this.loadLinkedData();
    }

    if (
      prevState.data.cantidad !== this.state.data.cantidad ||
      prevState.prorrateo.numCuotas !== this.state.prorrateo.numCuotas ||
      prevState.prorrateo.fechaPrimeraCuota !== this.state.prorrateo.fechaPrimeraCuota ||
      prevState.prorrateo.frecuenciaValor !== this.state.prorrateo.frecuenciaValor ||
      prevState.prorrateo.frecuenciaUnidad !== this.state.prorrateo.frecuenciaUnidad ||
      prevState.prorrateo.alinearInicioPeriodo !== this.state.prorrateo.alinearInicioPeriodo
    ) {
      this.rebuildCuotasPreview();
    }
  }

  buildInitialData(props, userData) {
    const dataDefault = {
      fecha: new Date(),
      concepto: "",
      detalle: "",
      cantidad: 0,
      fechaImputacion: null,
      IDCategoriaFK: { IDCategoria: null },
      cuentas: [
        {
          participacion: 100.0,
          IDCuentaFK: { IDCuenta: props.selectedAccount },
        },
      ],
      usuarios: [
        {
          participacion: 100.0,
          IDUsuarioFK: {
            IDUsuario: userData.IDUsuario,
          },
        },
      ],
    };

    if (props.mode !== "edit") return dataDefault;

    const normalizedInputData = {
      ...(props.data || {}),
      fecha: props.data?.fecha ? String(props.data.fecha).replace(/Z\[UTC\]$/, "") : "",
      fechaImputacion: props.data?.fechaImputacion
        ? String(props.data.fechaImputacion).replace(/Z\[UTC\]$/, "")
        : null,
    };

    return Object.assign({}, dataDefault, normalizedInputData);
  }

  closeModal = () => this.props.onCloseModal();

  handleFormChange = (data) => {
    this.setState({ data, error: "" });
  };

  toDateInputValue = (date) => {
    const d = new Date(date);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  };

  toLocalNoonDate = (value) => {
    if (!value) return null;
    if (value instanceof Date) {
      return new Date(value.getFullYear(), value.getMonth(), value.getDate(), 12, 0, 0, 0);
    }
    const txt = String(value).trim();
    const match = txt.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
      const [, year, month, day] = match;
      return new Date(Number(year), Number(month) - 1, Number(day), 12, 0, 0, 0);
    }
    const parsed = new Date(txt);
    if (isNaN(parsed.getTime())) return null;
    return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate(), 12, 0, 0, 0);
  };

  toAccountingMonthStart = (value) => {
    const d = this.toLocalNoonDate(value);
    if (!d) return null;
    return new Date(d.getFullYear(), d.getMonth(), 1, 12, 0, 0, 0);
  };

  defaultAccountingDate = () => {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), 1, 12, 0, 0, 0);
  };

  buildTransactionPayload = () => {
    const fecha = this.toLocalNoonDate(this.state.data.fecha);
    let fechaImputacion = this.toAccountingMonthStart(this.state.data.fechaImputacion);

    if (!fecha && !fechaImputacion) {
      fechaImputacion = this.defaultAccountingDate();
    }

    return {
      ...this.state.data,
      fecha,
      fechaImputacion,
    };
  };

  formatDateToIso = (value) => {
    const d = this.toLocalNoonDate(value);
    if (!d) return null;
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  };

  getCurrentAccountInfo = () => {
    const accountId = this.state?.data?.cuentas?.[0]?.IDCuentaFK?.IDCuenta;
    const acc = (this.props.allUserAccounts || []).find((a) => Number(a.IDCuenta) === Number(accountId));
    return acc || null;
  };

  isPersonalAccount = () => {
    const acc = this.getCurrentAccountInfo();
    return (acc?.tipo || "PERSONAL") === "PERSONAL";
  };

  createGastoPeriodicoFromTransaction = async (payload) => {
    const accountId = payload?.cuentas?.[0]?.IDCuentaFK?.IDCuenta;
    const concepto = String(payload?.concepto || "").trim();
    const importe = Math.abs(Number(payload?.cantidad || 0));
    const fechaInicio = this.formatDateToIso(payload?.fechaImputacion || payload?.fecha);
    const idCategoria = payload?.IDCategoriaFK?.IDCategoria || null;
    const { periodicidadGastoPeriodico, fechaFinGastoPeriodico } = this.state;

    if (!accountId || !concepto || !importe || !fechaInicio) {
      return { ok: false, message: "No se pudo convertir a gasto periodico por datos incompletos." };
    }

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        concepto,
        importeEstimado: importe,
        idCategoria,
        idCuenta: Number(accountId),
        periodicidad: periodicidadGastoPeriodico,
        fechaInicio,
        fechaFin: fechaFinGastoPeriodico || null,
      }),
    };

    try {
      const json = await doFetch("CCON", "insertGastoPeriodico", requestOptions).then((r) => r.json());
      if (json.STATE === "SUCCESS") {
        return { ok: true };
      }
      return { ok: false, message: json.MESSAGE || "No se pudo crear el gasto periodico." };
    } catch (e) {
      return { ok: false, message: "Error de conexion al crear el gasto periodico." };
    }
  };

  round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

  getSignedTotal = () => {
    const raw = Number(this.state.data?.cantidad || 0);
    if (isNaN(raw) || raw === 0) return 0;
    return this.round2(raw);
  };

  addFrequencyToDate = (baseDate, idx, stepValue, stepUnit) => {
    const d = new Date(baseDate.getTime());
    const shift = idx * stepValue;
    switch (stepUnit) {
      case "DIAS":
        d.setDate(d.getDate() + shift);
        break;
      case "SEMANAS":
        d.setDate(d.getDate() + shift * 7);
        break;
      case "ANIOS":
        d.setFullYear(d.getFullYear() + shift);
        break;
      case "MESES":
      default:
        d.setMonth(d.getMonth() + shift);
        break;
    }
    return d;
  };

  alignToPeriodStart = (dateValue, unit) => {
    const d = new Date(dateValue.getTime());
    switch (unit) {
      case "SEMANAS": {
        const day = d.getDay();
        const diffToMonday = (day + 6) % 7;
        d.setDate(d.getDate() - diffToMonday);
        break;
      }
      case "MESES":
        d.setDate(1);
        break;
      case "ANIOS":
        d.setMonth(0, 1);
        break;
      case "DIAS":
      default:
        break;
    }
    return d;
  };

  formatDateLabel = (dateValue) => {
    const d = new Date(dateValue);
    if (isNaN(d.getTime())) return "-";
    return d.toLocaleDateString("es-ES");
  };

  rebuildCuotasPreview = () => {
    const total = this.getSignedTotal();
    const n = Math.max(2, Math.min(60, parseInt(this.state.prorrateo.numCuotas, 10) || 2));
    const stepValue = Math.max(1, parseInt(this.state.prorrateo.frecuenciaValor, 10) || 1);
    const stepUnit = this.state.prorrateo.frecuenciaUnidad || "MESES";
    const alignPeriodStart = !!this.state.prorrateo.alinearInicioPeriodo;
    const startDate = this.toLocalNoonDate(this.state.prorrateo.fechaPrimeraCuota);
    const prev = Array.isArray(this.state.cuotasPreview) ? this.state.cuotasPreview : [];

    const manualAmountMap = new Map();
    const manualDateMap = new Map();
    prev.forEach((row) => {
      if (row.manualAmount) manualAmountMap.set(row.idx, this.round2(row.importe));
      if (row.manualDate && row.fecha) manualDateMap.set(row.idx, row.fecha);
    });

    let manualSum = 0;
    const autoIndices = [];
    for (let i = 1; i <= n; i += 1) {
      if (manualAmountMap.has(i)) {
        manualSum = this.round2(manualSum + manualAmountMap.get(i));
      } else {
        autoIndices.push(i);
      }
    }

    let remaining = this.round2(total - manualSum);
    const autoValues = new Map();
    if (autoIndices.length > 0) {
      const base = this.round2(remaining / autoIndices.length);
      let assigned = 0;
      autoIndices.forEach((idx, pos) => {
        const value = pos === 0 ? this.round2(remaining - this.round2(base * (autoIndices.length - 1))) : base;
        autoValues.set(idx, value);
        assigned = this.round2(assigned + value);
      });
      remaining = this.round2(remaining - assigned);
    }

    const cuotasPreview = [];
    for (let i = 1; i <= n; i += 1) {
      const amount = manualAmountMap.has(i) ? manualAmountMap.get(i) : autoValues.get(i) || 0;

      let cuotaDate = startDate ? this.addFrequencyToDate(startDate, i - 1, stepValue, stepUnit) : null;
      if (cuotaDate && alignPeriodStart && !manualDateMap.has(i)) {
        cuotaDate = this.alignToPeriodStart(cuotaDate, stepUnit);
      }

      const cuotaDateTxt = manualDateMap.has(i)
        ? manualDateMap.get(i)
        : (cuotaDate ? this.toDateInputValue(cuotaDate) : "");
      const cuotaDateObj = cuotaDateTxt ? this.toLocalNoonDate(cuotaDateTxt) : null;

      cuotasPreview.push({
        idx: i,
        fecha: cuotaDateTxt,
        fechaLabel: cuotaDateObj ? this.formatDateLabel(cuotaDateObj) : "-",
        importe: this.round2(amount),
        manualAmount: manualAmountMap.has(i),
        manualDate: manualDateMap.has(i),
      });
    }

    const totalAsignado = this.round2(cuotasPreview.reduce((acc, row) => acc + Number(row.importe || 0), 0));
    const diferencia = this.round2(total - totalAsignado);

    this.setState({
      cuotasPreview,
      cuotasResumen: {
        totalEsperado: total,
        totalAsignado,
        diferencia,
      },
    });
  };

  handleCuotaImporteChange = (idx, value) => {
    const parsed = Number(String(value).replace(",", "."));
    if (isNaN(parsed)) return;

    this.setState(
      (prev) => ({
        cuotasPreview: (prev.cuotasPreview || []).map((row) =>
          row.idx === idx ? { ...row, importe: this.round2(parsed), manualAmount: true } : row
        ),
      }),
      this.rebuildCuotasPreview
    );
  };

  handleCuotaFechaChange = (idx, value) => {
    if (!value) return;
    this.setState(
      (prev) => ({
        cuotasPreview: (prev.cuotasPreview || []).map((row) =>
          row.idx === idx
            ? { ...row, fecha: value, fechaLabel: this.formatDateLabel(value), manualDate: true }
            : row
        ),
      }),
      this.rebuildCuotasPreview
    );
  };

  resetCuotaAmountToAuto = (idx) => {
    this.setState(
      (prev) => ({
        cuotasPreview: (prev.cuotasPreview || []).map((row) =>
          row.idx === idx ? { ...row, manualAmount: false } : row
        ),
      }),
      this.rebuildCuotasPreview
    );
  };

  resetCuotaDateToAuto = (idx) => {
    this.setState(
      (prev) => ({
        cuotasPreview: (prev.cuotasPreview || []).map((row) =>
          row.idx === idx ? { ...row, manualDate: false } : row
        ),
      }),
      this.rebuildCuotasPreview
    );
  };

  updateProrrateoField = (field, value) => {
    this.setState((prev) => ({
      prorrateo: {
        ...prev.prorrateo,
        [field]: value,
      },
      error: "",
    }));
  };

  loadLinkedData = async () => {
    const { data } = this.state;
    const isBudgetTx = !!data.estadoPresupuesto;
    const isChildTx = data.idPresupuestoOrigenFK > 0;

    if (isBudgetTx) {
      if (data.estadoPresupuesto === "CONFIRMADO") {
        this.setState({ loadingLinked: true });
        try {
          const json = await doFetch("CCON", `getChildTransaction?IDTransaccionPresupuesto=${data.IDTransaccion}`, {
            method: "GET",
          }).then((r) => r.json());
          if (json.STATE === "SUCCESS") {
            this.setState({ childTransaction: json.DATA });
          }
        } catch (e) {
          // ignore, show empty
        } finally {
          this.setState({ loadingLinked: false });
        }
      } else if (data.estadoPresupuesto === "PLANIFICADO") {
        // load non-budget accounts for the "Asociar a cuenta" picker — use allUserAccounts prop (non-BUDGET only)
        // (no fetch needed — accountOptions are already passed as props)
      }
    } else if (isChildTx) {
      this.setState({ loadingLinked: true });
      try {
        const json = await doFetch("CCON", `getPresupuestoById?IDTransaccion=${data.idPresupuestoOrigenFK}`, {
          method: "GET",
        }).then((r) => r.json());
        if (json.STATE === "SUCCESS") {
          this.setState({ parentPresupuesto: json.DATA });
        }
      } catch (e) {
        // ignore
      } finally {
        this.setState({ loadingLinked: false });
      }
    } else {
      // Regular tx without parent: load planificados list
      this.setState({ loadingLinked: true });
      try {
        const json = await doFetch("CCON", "getPresupuestosPlanificados", {
          method: "GET",
        }).then((r) => r.json());
        if (json.STATE === "SUCCESS") {
          this.setState({ presupuestosPlanificados: json.DATA || [] });
        }
      } catch (e) {
        // ignore
      } finally {
        this.setState({ loadingLinked: false });
      }
    }
  };

  handleAsociarACuenta = async (idCuentaDestino, fechaCargo) => {
    if (!idCuentaDestino || !fechaCargo) {
      this.setState({ error: "Selecciona una cuenta y una fecha de cargo." });
      return;
    }
    this.setState({ saving: true, error: "" });
    this.props.onLoading(true);
    try {
      const json = await doFetch("CCON", "confirmarPresupuesto", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          idTransaccionPresupuesto: this.state.data.IDTransaccion,
          idCuentaDestino: Number(idCuentaDestino),
          fechaCargo,
        }),
      }).then((r) => r.json());

      if (json.STATE === "SUCCESS") {
        this.closeModal();
      } else {
        this.setState({ error: json.MESSAGE || "No se pudo asociar el presupuesto a la cuenta." });
      }
    } catch (e) {
      this.setState({ error: "Error de conexión al confirmar el presupuesto." });
    } finally {
      this.props.onLoading(false);
      this.setState({ saving: false });
    }
  };

  handleVincularTxPresupuesto = async () => {
    const { vinculoIdTxPresupuesto, data } = this.state;
    if (!vinculoIdTxPresupuesto) {
      this.setState({ error: "Selecciona una transaccion de presupuesto." });
      return;
    }
    this.setState({ saving: true, error: "" });
    this.props.onLoading(true);
    try {
      const json = await doFetch("CCON", "asociarTransaccionPresupuesto", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          idTransaccion: data.IDTransaccion,
          idTransaccionPresupuesto: Number(vinculoIdTxPresupuesto),
        }),
      }).then((r) => r.json());

      if (json.STATE === "SUCCESS") {
        this.closeModal();
      } else {
        this.setState({ error: json.MESSAGE || "No se pudo vincular la transaccion al presupuesto." });
      }
    } catch (e) {
      this.setState({ error: "Error de conexión al vincular." });
    } finally {
      this.props.onLoading(false);
      this.setState({ saving: false });
    }
  };

  handleCrearEnPresupuesto = async () => {
    const { vinculoIdCuentaPresupuesto, data } = this.state;
    if (!vinculoIdCuentaPresupuesto) {
      this.setState({ error: "Selecciona una cuenta de presupuesto." });
      return;
    }
    this.setState({ saving: true, error: "" });
    this.props.onLoading(true);
    try {
      const json = await doFetch("CCON", "crearPresupuestoYAsociar", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          idTransaccion: data.IDTransaccion,
          idCuentaPresupuesto: Number(vinculoIdCuentaPresupuesto),
        }),
      }).then((r) => r.json());

      if (json.STATE === "SUCCESS") {
        this.closeModal();
      } else {
        this.setState({ error: json.MESSAGE || "No se pudo crear el presupuesto asociado." });
      }
    } catch (e) {
      this.setState({ error: "Error de conexión al crear el presupuesto." });
    } finally {
      this.props.onLoading(false);
      this.setState({ saving: false });
    }
  };

  // Returns true for budget transactions (by estadoPresupuesto OR by account type as fallback)
  detectIsBudgetTx() {
    const { data } = this.state;
    if (data.estadoPresupuesto) return true;
    const accountId = data?.cuentas?.[0]?.IDCuentaFK?.IDCuenta;
    const acc = (this.props.allUserAccounts || []).find((a) => Number(a.IDCuenta) === Number(accountId));
    return acc?.tipo === "BUDGET";
  }

  renderPresupuestoTab() {
    const { data, childTransaction, parentPresupuesto, loadingLinked, presupuestosPlanificados,
      vinculoMode, vinculoIdTxPresupuesto, vinculoIdCuentaPresupuesto, saving, mostrarFormAsociar,
      pendingPresupuestoLink } = this.state;

    const allAccounts = this.props.allUserAccounts || [];
    const isBudgetTx = this.detectIsBudgetTx();
    const estadoPresupuesto = data.estadoPresupuesto || (isBudgetTx ? "PLANIFICADO" : null);
    const isChildTx = !isBudgetTx && Number(data.idPresupuestoOrigenFK) > 0;

    const budgetAccounts = allAccounts.filter((a) => a.tipo === "BUDGET");
    const nonBudgetAccountOptions = (this.props.accountOptions && this.props.accountOptions.length > 0)
      ? this.props.accountOptions
      : allAccounts.filter((a) => a.tipo !== "BUDGET").map((a) => ({ IDCuenta: a.IDCuenta, nombre: a.nombre }));

    const isEditMode = this.props.mode === "edit";

    /* ---- MODO NUEVA TRANSACCION: vincular a presupuesto al guardar ---- */
    if (!isEditMode) {
      return (
        <div className="p-3">
          <h6 className="fw-semibold mb-2">Vincular con una partida de presupuesto</h6>
          <small className="text-muted d-block mb-3">
            Opcional. Si seleccionas una partida, la nueva transacción quedará vinculada al guardar.
          </small>
          {loadingLinked ? (
            <div className="text-muted small">Cargando partidas...</div>
          ) : presupuestosPlanificados.length === 0 ? (
            <div className="text-muted small">No hay partidas de presupuesto planificadas disponibles.</div>
          ) : (
            <select
              className="form-select form-select-sm"
              value={pendingPresupuestoLink || ""}
              onChange={(e) => this.setState({ pendingPresupuestoLink: e.target.value || null })}
            >
              <option value="">-- Sin vincular (opcinal) --</option>
              {presupuestosPlanificados.map((p) => (
                <option key={p.idTransaccion} value={p.idTransaccion}>
                  {p.cuentaNombre} — {p.concepto} ({Number(p.cantidad).toFixed(2)} €)
                </option>
              ))}
            </select>
          )}
          {pendingPresupuestoLink && (
            <div className="alert alert-info py-2 mt-3 small mb-0">
              <MDBIcon icon="link" className="me-2" />
              Al guardar, esta transacción se vinculará automáticamente a la partida seleccionada.
            </div>
          )}
        </div>
      );
    }

    if (loadingLinked) {
      return <div className="p-3 text-muted">Cargando información...</div>;
    }

    /* ---- PARTIDA DE PRESUPUESTO ---- */
    if (isBudgetTx) {
      if (estadoPresupuesto === "PLANIFICADO") {
        return (
          <div className="p-3">
            <div className="alert alert-warning py-2 mb-3 small">
              Esta partida está <strong>planificada</strong> y aún no tiene transacción de cargo en ninguna cuenta.
            </div>
            {!mostrarFormAsociar ? (
              <MDBBtn color="success" size="sm" onClick={() => this.setState({ mostrarFormAsociar: true, error: "" })}>
                <MDBIcon icon="link" className="me-2" />
                Asociar a una cuenta real
              </MDBBtn>
            ) : (
              <AsociarACuentaForm
                accountOptions={nonBudgetAccountOptions}
                saving={saving}
                onAsociar={this.handleAsociarACuenta}
                onCancel={() => this.setState({ mostrarFormAsociar: false, error: "" })}
              />
            )}
          </div>
        );
      }

      if (estadoPresupuesto === "CONFIRMADO") {
        return (
          <div className="p-3">
            <h6 className="fw-semibold mb-3">Transacción de cargo asociada</h6>
            {childTransaction
              ? <LinkedTxCard tx={childTransaction} />
              : <div className="text-muted small">No se encontró la transacción de cargo asociada.</div>}
          </div>
        );
      }

      if (estadoPresupuesto === "CANCELADO") {
        return (
          <div className="p-3">
            <div className="alert alert-secondary mb-0">
              Esta partida está cancelada. Puedes replanificarla desde la vista de cuenta si deseas volver a activarla.
            </div>
          </div>
        );
      }
    }

    /* ---- TRANSACCIÓN NORMAL CON PRESUPUESTO DE ORIGEN ---- */
    if (isChildTx) {
      return (
        <div className="p-3">
          <h6 className="fw-semibold mb-3">Partida de presupuesto de origen</h6>
          {parentPresupuesto
            ? <LinkedTxCard tx={parentPresupuesto} isBudget />
            : <div className="text-muted small">No se pudo cargar la partida de presupuesto de origen.</div>}
        </div>
      );
    }

    /* ---- TRANSACCIÓN NORMAL SIN VÍNCULO (fallback) ---- */
    return (
      <div className="p-3">
        <h6 className="fw-semibold mb-3">Vincular con un presupuesto</h6>

        <div className="d-flex gap-2 mb-3">
          <button
            type="button"
            className={`btn btn-sm ${vinculoMode === "existente" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => this.setState({ vinculoMode: "existente", error: "" })}
          >
            Partida de presupuesto ya creada
          </button>
          <button
            type="button"
            className={`btn btn-sm ${vinculoMode === "nueva" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => this.setState({ vinculoMode: "nueva", error: "" })}
          >
            Crear nueva partida de presupuesto
          </button>
        </div>

        {vinculoMode === "existente" && (
          <div>
            {presupuestosPlanificados.length === 0 ? (
              <div className="text-muted small">No hay partidas de presupuesto planificadas disponibles.</div>
            ) : (
              <>
                <label className="form-label small fw-semibold">Selecciona la partida de presupuesto</label>
                <select
                  className="form-select form-select-sm mb-2"
                  value={vinculoIdTxPresupuesto}
                  onChange={(e) => this.setState({ vinculoIdTxPresupuesto: e.target.value, error: "" })}
                >
                  <option value="">-- Seleccionar --</option>
                  {presupuestosPlanificados.map((p) => (
                    <option key={p.idTransaccion} value={p.idTransaccion}>
                      {p.cuentaNombre} — {p.concepto} ({Number(p.cantidad).toFixed(2)} €)
                    </option>
                  ))}
                </select>
                <MDBBtn
                  size="sm"
                  color="primary"
                  onClick={this.handleVincularTxPresupuesto}
                  disabled={saving || !vinculoIdTxPresupuesto}
                >
                  {saving ? "Vinculando..." : "Vincular"}
                </MDBBtn>
              </>
            )}
          </div>
        )}

        {vinculoMode === "nueva" && (
          <div>
            {budgetAccounts.length === 0 ? (
              <div className="text-muted small">No tienes cuentas de presupuesto disponibles.</div>
            ) : (
              <>
                <label className="form-label small fw-semibold">Cuenta de presupuesto</label>
                <select
                  className="form-select form-select-sm mb-2"
                  value={vinculoIdCuentaPresupuesto}
                  onChange={(e) => this.setState({ vinculoIdCuentaPresupuesto: e.target.value, error: "" })}
                >
                  <option value="">-- Seleccionar --</option>
                  {budgetAccounts.map((a) => (
                    <option key={a.IDCuenta} value={a.IDCuenta}>
                      {a.nombre}
                    </option>
                  ))}
                </select>
                <small className="text-muted d-block mb-2">
                  Se creará una partida de presupuesto en esta cuenta copiando el concepto y la cantidad de esta transacción.
                </small>
                <MDBBtn
                  size="sm"
                  color="primary"
                  onClick={this.handleCrearEnPresupuesto}
                  disabled={saving || !vinculoIdCuentaPresupuesto}
                >
                  {saving ? "Creando..." : "Crear y vincular"}
                </MDBBtn>
              </>
            )}
          </div>
        )}
      </div>
    );
  }

  saveTransaction = async (event) => {    if (event?.preventDefault) event.preventDefault();

    this.setState({ saving: true, error: "" });
    this.props.onLoading(true);

    try {
      let payload = this.buildTransactionPayload();

      // Si en modo new el usuario seleccionó un presupuesto para vincular, incluirlo en el payload
      if (this.props.mode !== "edit" && this.state.pendingPresupuestoLink) {
        payload = { ...payload, idPresupuestoOrigenFK: Number(this.state.pendingPresupuestoLink) };
      }

      const endpoint = this.props.mode === "edit" ? "updateTransactions" : "insertTransactions";
      const json = await doFetch("CCON", endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify([payload]),
      }).then((r) => r.json());

      if (json.STATE === "SUCCESS") {
        if (this.state.convertirEnGastoPeriodico && this.isPersonalAccount()) {
          const conv = await this.createGastoPeriodicoFromTransaction(payload);
          if (!conv.ok) {
            window.alert(`Transaccion guardada, pero no se pudo crear el gasto periodico: ${conv.message}`);
          }
        }
        this.closeModal();
      } else {
        this.setState({ error: json.MESSAGE || "No se pudo guardar la transaccion." });
      }
    } catch (error) {
      this.setState({ error: "Error de conexion al guardar la transaccion." });
    } finally {
      this.props.onLoading(false);
      this.setState({ saving: false });
    }
  };

  saveProrrateo = async () => {
    const { concepto, cantidad, IDCategoriaFK } = this.state.data;
    const { numCuotas, fechaPrimeraCuota, frecuenciaValor, frecuenciaUnidad } = this.state.prorrateo;

    if (!this.state.prorrateoEnabled) {
      this.setState({ error: "Activa el modo prorrateo para continuar." });
      return;
    }

    if (!concepto || !String(concepto).trim()) {
      this.setState({ error: "El concepto es obligatorio para crear prorrateo." });
      return;
    }

    const total = Number(cantidad || 0);
    if (!total || isNaN(total)) {
      this.setState({ error: "La cantidad debe ser valida para prorratear." });
      return;
    }

    const n = Number(numCuotas);
    if (!Number.isInteger(n) || n < 2 || n > 60) {
      this.setState({ error: "El numero de cuotas debe estar entre 2 y 60." });
      return;
    }

    const fValue = Number(frecuenciaValor);
    if (!Number.isInteger(fValue) || fValue < 1 || fValue > 365) {
      this.setState({ error: "La frecuencia numerica debe estar entre 1 y 365." });
      return;
    }

    if (!fechaPrimeraCuota) {
      this.setState({ error: "Selecciona una fecha inicial para el prorrateo." });
      return;
    }

    const cuotasRows = this.state.cuotasPreview || [];
    const cuotas = cuotasRows.map((row) => this.round2(Number(row.importe || 0)));
    const fechasCuotas = cuotasRows.map((row) => row.fecha || null);

    if (cuotas.length !== n) {
      this.setState({ error: "No se pudo preparar la tabla de cuotas. Revisa los datos." });
      return;
    }

    const totalCuotas = this.round2(cuotas.reduce((acc, val) => acc + val, 0));
    if (Math.abs(this.round2(total - totalCuotas)) > 0.01) {
      this.setState({ error: "La suma de cuotas no coincide con el total de la transaccion." });
      return;
    }

    this.setState({ saving: true, error: "" });
    this.props.onLoading(true);

    try {
      const body = {
        concepto: String(concepto).trim(),
        importeTotal: this.round2(total),
        numCuotas: n,
        fechaPrimeraCuota,
        frecuencia: `${fValue} ${frecuenciaUnidad}`,
        frecuenciaValor: fValue,
        frecuenciaUnidad,
        IDCuenta: this.state.data?.cuentas?.[0]?.IDCuentaFK?.IDCuenta || this.props.selectedAccount,
        IDCategoriaFK: IDCategoriaFK?.IDCategoria || null,
        IDTransaccionOrigen: this.props.mode === "edit" ? this.state.data?.IDTransaccion || null : null,
        importesCuotas: cuotas,
        fechasCuotas,
      };

      const json = await doFetch("CCON", "insertProrrateo", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      }).then((r) => r.json());

      if (json.STATE === "OK" || json.STATE === "SUCCESS") {
        this.closeModal();
      } else {
        this.setState({ error: json.MESSAGE || "No se pudo crear el prorrateo." });
      }
    } catch (error) {
      this.setState({ error: "Error de conexion al crear el prorrateo." });
    } finally {
      this.props.onLoading(false);
      this.setState({ saving: false });
    }
  };

  renderProrrateoHeader() {
    const { data, prorrateo } = this.state;
    const total = Number(data?.cantidad || 0);
    const categoria = data?.IDCategoriaFK?.nombre || data?.IDCategoriaFK?.IDCategoria || "Sin categoria";

    return (
      <div className="prorrateo-basic-header">
        <div className="pr-basic-item"><span>Concepto</span><strong>{data?.concepto || "-"}</strong></div>
        <div className="pr-basic-item"><span>Total</span><strong>{isNaN(total) ? "0.00" : total.toFixed(2)} €</strong></div>
        <div className="pr-basic-item"><span>Categoria</span><strong>{categoria}</strong></div>
        <div className="pr-basic-item"><span>Inicio</span><strong>{prorrateo.fechaPrimeraCuota || "-"}</strong></div>
      </div>
    );
  }

  renderCuotasTable() {
    if (!this.state.prorrateoEnabled) return null;

    const { cuotasPreview, cuotasResumen } = this.state;
    if (!cuotasPreview.length) return null;

    return (
      <div className="cuotas-table-wrap mt-3">
        <div className="cuotas-table-scroll">
          <MDBTable small responsive className="mb-0 cuotas-table">
            <MDBTableHead>
              <tr>
                <th>Cuota</th>
                <th>Fecha cuota</th>
                <th className="text-end">Importe</th>
                <th className="text-center">Modo importe</th>
                <th className="text-center">Modo fecha</th>
              </tr>
            </MDBTableHead>
            <MDBTableBody>
              {cuotasPreview.map((row) => (
                <tr key={row.idx}>
                  <td>{row.idx}</td>
                  <td style={{ minWidth: "180px" }}>
                    <input
                      className="form-control form-control-sm"
                      type="date"
                      value={row.fecha || ""}
                      onChange={(e) => this.handleCuotaFechaChange(row.idx, e.target.value)}
                    />
                    <small className="text-muted">{row.fechaLabel}</small>
                  </td>
                  <td style={{ minWidth: "150px" }}>
                    <input
                      className="form-control form-control-sm text-end"
                      type="number"
                      step="0.01"
                      value={row.importe}
                      onChange={(e) => this.handleCuotaImporteChange(row.idx, e.target.value)}
                    />
                  </td>
                  <td className="text-center">
                    {row.manualAmount ? (
                      <button
                        type="button"
                        className="btn btn-link btn-sm p-0"
                        onClick={() => this.resetCuotaAmountToAuto(row.idx)}
                        title="Volver a calculo automatico"
                      >
                        Manual
                      </button>
                    ) : (
                      <span className="badge rounded-pill text-bg-light">Auto</span>
                    )}
                  </td>
                  <td className="text-center">
                    {row.manualDate ? (
                      <button
                        type="button"
                        className="btn btn-link btn-sm p-0"
                        onClick={() => this.resetCuotaDateToAuto(row.idx)}
                        title="Volver a fecha automatica"
                      >
                        Manual
                      </button>
                    ) : (
                      <span className="badge rounded-pill text-bg-light">Auto</span>
                    )}
                  </td>
                </tr>
              ))}
            </MDBTableBody>
          </MDBTable>
        </div>

        <div className="cuotas-summary">
          <span>Total: <strong>{cuotasResumen.totalEsperado.toFixed(2)} €</strong></span>
          <span>Cuotas: <strong>{cuotasResumen.totalAsignado.toFixed(2)} €</strong></span>
          <span className={Math.abs(cuotasResumen.diferencia) <= 0.01 ? "ok" : "warn"}>
            Diferencia: <strong>{cuotasResumen.diferencia.toFixed(2)} €</strong>
          </span>
        </div>
      </div>
    );
  }

  render() {
    const isEditMode = this.props.mode === "edit";

    return (
      <MDBModal show={this.props.show} onHide={this.closeModal} tabIndex="-1">
        <MDBModalDialog size="xl" className="transaction-modal-dialog">
          <MDBModalContent>
            <MDBModalHeader className="transaction-modal-header">
              <div className="transaction-header-content">
                <MDBModalTitle>
                  <MDBIcon icon={isEditMode ? "edit" : "plus-circle"} className="me-2" />
                  {isEditMode ? "Editar transaccion" : "Nueva transaccion"}
                </MDBModalTitle>
                <p className="transaction-modal-subtitle">
                  Gestion unificada en pestañas: datos y prorrateo.
                </p>
              </div>
              <MDBBtn className="btn-close" color="none" onClick={this.closeModal}></MDBBtn>
            </MDBModalHeader>

            <MDBModalBody className="transaction-modal-body-compact">
              <div className="modal-tabs-row">
                <button
                  type="button"
                  className={`tab-btn ${this.state.activeTab === "transaccion" ? "active" : ""}`}
                  onClick={() => this.setState({ activeTab: "transaccion" })}
                >
                  Datos de la transaccion
                </button>
                <button
                  type="button"
                  className={`tab-btn ${this.state.activeTab === "prorrateo" ? "active" : ""}`}
                  onClick={() => this.setState({ activeTab: "prorrateo" })}
                >
                  Prorrateo
                </button>
                {isEditMode && (
                  <button
                    type="button"
                    className={`tab-btn ${this.state.activeTab === "presupuesto" ? "active" : ""}`}
                    onClick={() => this.setState({ activeTab: "presupuesto" })}
                  >
                    Presupuesto
                  </button>
                )}
                {!isEditMode && !this.detectIsBudgetTx() && (
                  <button
                    type="button"
                    className={`tab-btn ${this.state.activeTab === "presupuesto" ? "active" : ""}`}
                    onClick={() => this.setState({ activeTab: "presupuesto" })}
                  >
                    Vincular a presupuesto
                  </button>
                )}
              </div>

              {this.state.activeTab === "transaccion" && (
                <div className="transaction-panel transaction-form-panel modal-tab-content">
                  <TransactionForm
                    data={this.state.data}
                    onChange={this.handleFormChange}
                    onSubmit={this.saveTransaction}
                    onLoading={(event) => this.props.onLoading(event)}
                    conceptosSugeridos={this.props.conceptosSugeridos || []}
                    accountOptions={this.props.accountOptions || []}
                    hideSubmitButton={true}
                    compactMode={true}
                    fullWidth={true}
                  />

                  {this.isPersonalAccount() && (
                    <div className="mt-2 p-3 border rounded" style={{ background: "#f8f9fa" }}>
                      <div className="form-check form-switch mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="toggleGastoPeriodico"
                          checked={this.state.convertirEnGastoPeriodico}
                          onChange={(e) => this.setState({ convertirEnGastoPeriodico: e.target.checked })}
                        />
                        <label className="form-check-label" htmlFor="toggleGastoPeriodico">
                          Convertir esta transaccion en gasto periodico
                        </label>
                      </div>

                      {this.state.convertirEnGastoPeriodico && (
                        <div className="row g-2 align-items-end">
                          <div className="col-12 col-md-5">
                            <label className="form-label small fw-semibold">Periodicidad</label>
                            <select
                              className="form-select form-select-sm"
                              value={this.state.periodicidadGastoPeriodico}
                              onChange={(e) => this.setState({ periodicidadGastoPeriodico: e.target.value })}
                            >
                              {PERIODICIDADES.map((p) => (
                                <option key={p.value} value={p.value}>{p.label}</option>
                              ))}
                            </select>
                          </div>
                          <div className="col-12 col-md-7">
                            <label className="form-label small fw-semibold">Fecha de fin (opcional)</label>
                            <input
                              type="date"
                              className="form-control form-control-sm"
                              value={this.state.fechaFinGastoPeriodico}
                              onChange={(e) => this.setState({ fechaFinGastoPeriodico: e.target.value })}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {this.state.activeTab === "prorrateo" && (
                <div className="transaction-panel prorrateo-panel modal-tab-content">                  {this.renderProrrateoHeader()}

                  <div className="prorrateo-header-row mt-3">
                    <h6 className="section-title mb-0">Configuracion de frecuencia</h6>
                    <div className="form-check form-switch mb-0">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="toggleProrrateoInline"
                        checked={this.state.prorrateoEnabled}
                        onChange={(e) => this.setState({ prorrateoEnabled: e.target.checked, error: "" })}
                      />
                      <label className="form-check-label" htmlFor="toggleProrrateoInline">
                        Activar
                      </label>
                    </div>
                  </div>

                  <div className="prorrateo-grid mt-2">
                    <div className="pr-field pr-field-cuotas">
                      <label className="form-label small fw-semibold">Nº cuotas</label>
                      <input
                        type="number"
                        min="2"
                        max="60"
                        className="form-control form-control-sm"
                        value={this.state.prorrateo.numCuotas}
                        disabled={!this.state.prorrateoEnabled}
                        onChange={(e) => this.updateProrrateoField("numCuotas", e.target.value)}
                      />
                    </div>
                    <div className="pr-field pr-field-fecha">
                      <label className="form-label small fw-semibold">Fecha inicial</label>
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        value={this.state.prorrateo.fechaPrimeraCuota}
                        disabled={!this.state.prorrateoEnabled}
                        onChange={(e) => this.updateProrrateoField("fechaPrimeraCuota", e.target.value)}
                      />
                    </div>
                    <div className="pr-field pr-field-frecuencia">
                      <label className="form-label small fw-semibold">Cada</label>
                      <div className="frequency-combo">
                        <input
                          type="number"
                          min="1"
                          max="365"
                          className="form-control form-control-sm"
                          value={this.state.prorrateo.frecuenciaValor}
                          disabled={!this.state.prorrateoEnabled}
                          onChange={(e) => this.updateProrrateoField("frecuenciaValor", e.target.value)}
                        />
                        <select
                          className="form-select form-select-sm"
                          value={this.state.prorrateo.frecuenciaUnidad}
                          disabled={!this.state.prorrateoEnabled}
                          onChange={(e) => this.updateProrrateoField("frecuenciaUnidad", e.target.value)}
                        >
                          {FREQUENCY_UNITS.map((unit) => (
                            <option key={unit.value} value={unit.value}>{unit.label}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="pr-field pr-field-align">
                      <label className="form-label small fw-semibold d-flex align-items-center gap-2 mb-1">
                        Alineación auto
                        <MDBIcon
                          icon="info-circle"
                          className="prorrateo-info-icon"
                          title="Ajusta automaticamente las fechas al inicio de cada periodo: mes = dia 1, semana = lunes, anio = 1 de enero."
                        />
                      </label>
                      <div className="form-check form-switch mt-0 prorrateo-align-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="alignStartPeriod"
                          checked={!!this.state.prorrateo.alinearInicioPeriodo}
                          disabled={!this.state.prorrateoEnabled}
                          onChange={(e) => this.updateProrrateoField("alinearInicioPeriodo", e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="alignStartPeriod">
                          Inicio periodo
                        </label>
                      </div>
                    </div>
                  </div>

                  {this.renderCuotasTable()}
                </div>
              )}

              {this.state.activeTab === "presupuesto" && (
                <div className="transaction-panel modal-tab-content">
                  {this.renderPresupuestoTab()}
                </div>
              )}

              {this.state.error && <div className="alert alert-danger py-2 mt-2 mb-0">{this.state.error}</div>}
            </MDBModalBody>

            <MDBModalFooter>
              <MDBBtn color="secondary" outline onClick={this.closeModal} disabled={this.state.saving}>
                Cancelar
              </MDBBtn>
              {this.state.activeTab === "transaccion" && (
                <MDBBtn color="primary" onClick={this.saveTransaction} disabled={this.state.saving}>
                  {this.state.saving ? "Guardando..." : isEditMode ? "Guardar cambios" : "Guardar transaccion"}
                </MDBBtn>
              )}
              {this.state.activeTab === "prorrateo" && (
                <MDBBtn
                  color="warning"
                  onClick={this.saveProrrateo}
                  disabled={this.state.saving || !this.state.prorrateoEnabled}
                >
                  {this.state.saving ? "Procesando..." : "Guardar prorrateo"}
                </MDBBtn>
              )}
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    );
  }
}

/* ---- Helper: "Asociar a cuenta" form for PLANIFICADO budget tx ---- */
class AsociarACuentaForm extends React.Component {
  constructor(props) {
    super(props);
    const today = new Date();
    this.state = {
      idCuentaDestino: "",
      fechaCargo: `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`,
    };
  }

  render() {
    const { accountOptions, saving, onAsociar, onCancel } = this.props;
    const { idCuentaDestino, fechaCargo } = this.state;
    return (
      <div>
        <h6 className="fw-semibold mb-2">Datos del cargo en cuenta</h6>
        <p className="text-muted small mb-3">
          Se generará una transacción real en la cuenta seleccionada con los datos de esta partida, que pasará a estado CONFIRMADO.
        </p>
        <div className="mb-2">
          <label className="form-label small fw-semibold">Cuenta donde se registrará el cargo</label>
          <select
            className="form-select form-select-sm"
            value={idCuentaDestino}
            onChange={(e) => this.setState({ idCuentaDestino: e.target.value })}
          >
            <option value="">-- Seleccionar cuenta --</option>
            {(accountOptions || []).map((opt) => (
              <option key={opt.IDCuenta || opt.value} value={opt.IDCuenta || opt.value}>
                {opt.nombre || opt.label}
              </option>
            ))}
          </select>
        </div>
        <div className="mb-3">
          <label className="form-label small fw-semibold">Fecha del cargo</label>
          <input
            type="date"
            className="form-control form-control-sm"
            value={fechaCargo}
            onChange={(e) => this.setState({ fechaCargo: e.target.value })}
          />
        </div>
        <div className="d-flex gap-2">
          <MDBBtn
            size="sm"
            color="success"
            onClick={() => onAsociar(idCuentaDestino, fechaCargo)}
            disabled={saving || !idCuentaDestino || !fechaCargo}
          >
            {saving ? "Confirmando..." : "Confirmar y generar cargo"}
          </MDBBtn>
          <MDBBtn size="sm" color="secondary" outline onClick={onCancel} disabled={saving}>
            Cancelar
          </MDBBtn>
        </div>
      </div>
    );
  }
}

/* ---- Helper: card showing a linked transaction summary ---- */
function LinkedTxCard({ tx, isBudget }) {
  if (!tx) return null;
  const cantidad = Number(tx.cantidad || 0).toFixed(2);
  const fecha = tx.fecha ? String(tx.fecha).substring(0, 10) : "-";
  const estadoLabel = isBudget
    ? ({ PLANIFICADO: "Planificado", CONFIRMADO: "Confirmado", CANCELADO: "Cancelado" }[tx.estadoPresupuesto] || "Presupuesto")
    : "Transacción real";
  return (
    <div className="card card-body py-2 px-3 small">
      <div className="d-flex justify-content-between align-items-center mb-1">
        <strong>{tx.concepto || "-"}</strong>
        <span className={`badge ${isBudget ? "bg-warning text-dark" : "bg-primary"}`}>
          {estadoLabel}
        </span>
      </div>
      {tx.cuentaNombre && <div className="text-muted">Cuenta: {tx.cuentaNombre}</div>}
      <div>Importe: <strong>{cantidad} €</strong></div>
      {fecha !== "-" && <div className="text-muted">Fecha: {fecha}</div>}
      {tx.detalle && <div className="text-muted">Detalle: {tx.detalle}</div>}
    </div>
  );
}
